<template>
    <div v-show="selected > 0">
        {{$t(text, { count: selected })}}
    </div>
</template>

<script>
export default {
  name: 'selectCount',
  props: {
    selected: Number,
    text: {
      type: String,
      default: 'messageListBar.selected'
    }
  }
};
</script>

<style scoped lang="scss">
</style>
